import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const ModalityForm = ({ modalityId, initialData, onSuccess }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const [modalityName, setModalityName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // ✅ Fill form if initialData is provided (edit mode)
  useEffect(() => {
    if (initialData && initialData.mod_name) {
      setModalityName(initialData.mod_name);
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!modalityName.trim()) {
      setError('Modality name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let url = '';
      let method = 'POST';
      let body = {};

      if (modalityId) {
        // ✅ Edit mode
        url = `${baseUrl}/updateModalityById/${modalityId}`;
        body = { mod_name: modalityName };
      } else {
        // ✅ Create mode
        url = `${baseUrl}/createModality`;
        body = { mod_name: modalityName };
      }

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.status) {
        alert(modalityId ? 'Modality updated successfully' : 'Modality created successfully');
        if (onSuccess) onSuccess();
        navigate('/modality');
      } else {
        setError(data.message || `Failed to ${modalityId ? 'update' : 'create'} Modality`);
      }
    } catch (err) {
      setError('Error connecting to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="general-info-form" onSubmit={handleSubmit}>
      <h2 className="section-title">{modalityId ? 'Edit Modality' : 'Add Modality'}</h2>
      <div className="form-grid">
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="modalityName"
            placeholder=" "
            autoComplete="off"
            value={modalityName}
            onChange={(e) => setModalityName(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="modalityName">Modality Name</label>
        </div>
      </div>
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: '15px' }}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
    </form>
  );
};

export default ModalityForm;
